<template>
  <div class="map" ref="map">

  </div>
</template>

<script>
// https://geocode-maps.yandex.ru/1.x/?apikey=ваш API-ключ&geocode=37.611347,55.760241
export default {
  name: 'MapCreate',
  emits: [
    'changeAddress',
    'changeCoords',
    'pick'
  ],
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      const ymaps = window.ymaps
      const map = this.$refs.map

      ymaps.ready(() => {
        const myMap = new ymaps.Map(map, {
          center: [42.983555, 47.504044],
          zoom: 12,
          controls: ['zoomControl']
        })

        const searchControl = new ymaps.control.SearchControl({
          options: { provider: 'yandex#map' }
        })

        searchControl.events.add('submit', async function () {
          myMap.geoObjects.removeAll()
          const searchValue = searchControl.getRequestString()
          const res = await ymaps.geocode(searchValue)

          const firstGeoObject = res.geoObjects.get(0)
          const coords = firstGeoObject.geometry.getCoordinates()

          this.$emit('changeAddress', searchValue)
          this.$emit('changeCoords', coords)
        }, this)
        myMap.controls.add(searchControl)

        myMap.events.add('click', e => {
          searchControl.clear()
          myMap.geoObjects.removeAll()
          const coords = e.get('coords')

          const myPlacemark = new ymaps.Placemark(coords)

          myMap.geoObjects.add(myPlacemark)

          this.$emit('pick', coords)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  position: relative;
}
</style>
